import React from 'react';
import { connect, } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actions as rootActions } from '../actions'
import { NAME as MONITOR_NAME } from '../reducer'
import EditMonitor from './EditMonitor';
import LoadError from '../../../components/LoadError';
import SearchedTable from "../../../components/SearchedTable"
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';


function mapStateToProps(state) {
  return {
    ...state[MONITOR_NAME],
  }
}


const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...rootActions,
}, dispatch)


class MonitorList extends React.Component {
  constructor(props) {
    super(props);
    props.getWarehouseProductsList();
    props.getProductTypeList();
    props.getMonitorsList();
  }

  componentDidMount() {
    this.props.getProductTypeList()
    this.props.getWarehouseProductsList() // First we get warehouseproducts
    this.props.getMonitorsList();
  }

  reload = () => {
    this.props.getProductTypeList()
    this.props.getWarehouseProductsList()
    this.props.getMonitorsList()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.monitorsList !== this.props.monitorsList) {
      this.props.getWarehouseProductsList();
    }
  }

  render() {
    if (Object.values(this.props.loadErrors).some(Boolean)) {
      return <LoadError onRetry={this.reload} />
    }
    return (
      <>
        {this.props.showEdit ? <Grid container spacing={6}><Grid item xs={12}><EditMonitor /></Grid></Grid> : 
        <Grid container spacing={5}>
        <Grid item xs={12}>
          <SearchedTable
            tableTitle="Склады"
            tableDescription={{
            columns: this.props.tableColumns,
            data: this.props.monitorsList
          }}
            clickAction={(rowData, rowMeta) => {
              let id = rowData[0]
              this.props.editMonitorAction({
                selected: id,
                showEdit: true
              })
              //this.props.setCurrentCompany(id)
            }}
          />
        </Grid> </Grid>
        }
      </>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(MonitorList)
